//
// Copyright (c) 2011-2020 by Curalate, Inc.
//

import { IActionSheetButton } from '@components/molecules/action-sheet/ActionSheet';
import { IUiaModalClosedResponse } from '@legacy-components/common/universal-image-actions/models/events';
import Cuid from '@models/Cuid';
import ItemId from '@models/ItemId';
import { UniversalImageActionsViewName } from '@models/UniversalImageActionsView';
import { UniversalItemType } from '@models/UniversalItemType';
import { IShareRejectionReason } from '@share/models/shareStateModel';
import { openUia } from '@utils/uia';

const NUM_REJECTION_REASONS_IN_DROPDOWN = 3;

export const buildRejectionReasonsActionSheetConfig = (
  cuid: Cuid,
  clientRejectionReasons: IShareRejectionReason[] | undefined,
  openRejectionReasonsModal: (cuid: Cuid) => void,
  rejectItem: (cuid: Cuid, rejectionCode: number) => Promise<void>,
  openWhenNoReasons?: boolean,
) => {
  let rejectionReasonsButtons: IActionSheetButton[];

  rejectionReasonsButtons =
    clientRejectionReasons
      ?.slice(0, NUM_REJECTION_REASONS_IN_DROPDOWN)
      .map((reason) => ({
        label: reason.rejectionDescription,
        onClick: () => rejectItem(cuid, reason.rejectionCode),
      })) ?? [];

  if (
    clientRejectionReasons &&
    clientRejectionReasons.length > NUM_REJECTION_REASONS_IN_DROPDOWN
  ) {
    rejectionReasonsButtons = rejectionReasonsButtons.concat({
      label: 'More reasons...',
      onClick: () => openRejectionReasonsModal(cuid),
    });
  }

  return [
    {
      children:
        rejectionReasonsButtons.length > 0 || !openWhenNoReasons
          ? rejectionReasonsButtons
          : undefined,
      label: 'Reject Item',
      onClick:
        openWhenNoReasons && rejectionReasonsButtons.length === 0
          ? () => openRejectionReasonsModal(cuid)
          : undefined,
    },
  ];
};

export const openUiaToView = (
  event: React.MouseEvent,
  view: UniversalImageActionsViewName,
  itemType: UniversalItemType,
  itemId: ItemId,
  onClose: (itemId: ItemId, response: IUiaModalClosedResponse) => void,
) => {
  event.preventDefault();
  event.stopPropagation();

  const onUiaClose = (response: IUiaModalClosedResponse) => {
    onClose(itemId, response);
  };

  openUia({ itemType, itemId }, view, onUiaClose);
};
